import React from 'react'
import contact from 'Static/illustrations/contact.svg'
import { Container } from 'Common'
import { Wrapper, Details, Thumbnail } from './styles'
import ContactForm from './ContactForm'

export const Contact = () => (
	<Wrapper as={Container} id="contact">
		<Details>
			<h1>Say Hello!</h1>
			<p>
				If you wanna get in touch, talk to me about a project collaboration or
				just say hi, fill up the awesome form below or send an email to
				jainsuchi21@gmail.com and let's talk.
			</p>
			<ContactForm />
		</Details>
		<Thumbnail>
			<img src={contact} alt="I’m a Frontend Developer!" />
		</Thumbnail>
	</Wrapper>
)
